<app-step-dot-menu
  [projectId]="projectId"
  testId="step3-2-dot-menu-button"
  [preselectedRole]="ProjectRoleType.CONTRIBUTOR"
  [preselectedAccessiblePages]="[ProjectStepType.SYSTEM_INTEGRATION_CONFIG]"
></app-step-dot-menu>

<div class="card">
  @if (integrationSystemRecordingsResource.isLoading()) {
    <app-loading />
  } @else {
    <app-system-flow
      [projectId]="projectId"
      [isReadOnly]="isButtonDisabled()"
      [integrationSystemRecordings]="integrationSystemRecordingsResource.value()!"
    />
  }

  <app-system-recording-legend />

  <app-audit-info [auditInfo]="auditInfo()" />
</div>
